import { ScrollPaperDialog } from '@zmvp/material-ui'
import React from 'react'

import { CustomDialogTitle } from 'components'

export default React.forwardRef(function CustomScrollPaperDialog(
    { children, onClose, title, subtitle, fullScreen, ...props },
    ref
) {
    const dialogRef = React.useRef()

    React.useImperativeHandle(ref, () => ({
        open: () => dialogRef.current.open(),
        close: () => dialogRef.current.close()
    }))

    return (
        <ScrollPaperDialog
            title={
                <CustomDialogTitle
                    title={title}
                    subtitle={subtitle}
                    onClose={onClose}
                    isFullScreen={fullScreen}
                />
            }
            disableTypography
            ref={dialogRef}
            onClose={onClose}
            isFullScreen={fullScreen}
            {...props}
        >
            {children}
        </ScrollPaperDialog>
    )
})
